import { render, staticRenderFns } from "./UsersCardRightPanel.vue?vue&type=template&id=4493c83a&scoped=true&"
import script from "./UsersCardRightPanel.vue?vue&type=script&lang=ts&"
export * from "./UsersCardRightPanel.vue?vue&type=script&lang=ts&"
import style0 from "./UsersCardRightPanel.vue?vue&type=style&index=0&id=4493c83a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4493c83a",
  null
  
)

export default component.exports